import React from 'react';
import LettingHubCardBase from '../LettingHubCardBase';
const BACKGROUND_IMAGE_MOBILE = 'https://www.haven.com/assets/images/repair-card-mobile.jpeg';
const BACKGROUND_IMAGE_DESKTOP = 'https://www.haven.com/assets/images/repair-card-desktop.jpeg';
export const RepairPlanCard = ({ onClick, variant }) => {
    return (<LettingHubCardBase variant={variant} title='Repair cover plan' description={'<>Get extra peace of mind with our <b>Repair Cover Plan</b></>'} backgroundImageMobile={BACKGROUND_IMAGE_MOBILE} backgroundImageDesktop={BACKGROUND_IMAGE_DESKTOP} onClick={onClick}/>);
};
